import { selector } from 'recoil';
import { agentUserId } from '../atoms/agentUserId';
import { methodNameEnum, refetchToggle } from './makePHPRequest';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
export const getSmsTemplateByAgent = selector({
  key: 'getSmsTemplateByAgent',
  get: async ({ get }) => {
    try {
      // this is required here to subscribe to a change in addNewAgent atom-- this atom will only be changed on submititon of the add new agent form.
      const result = {};
      const currentUser = get(agentUserId);
      get(refetchToggle(endpointEnum.GET_SMS_TEMPLATE));
      if (currentUser.id) {
        // const url =
        //   `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php?` +
        //   querystring.stringify({
        //     call: 'getsmstemplate',
        //     businessid: storageUser.businessid,
        //     apiKey: storageUser.apikey,
        //   });
        // const result = await axios.post(url, null, { withCredentials: true });
        const data = {
          call: methodNameEnum.GET_SMS_TEMPLATE,
        };
        const { response } = get(
          makeAPIRequest({
            endpoint: endpointEnum.GET_SMS_TEMPLATE,
            payloadJsonString: JSON.stringify(data),
          })
        );
        const filteredById = response?.data?.result?.filter(
          (sms) => sms.userid === +currentUser.id
        );
        result.filteredByAgent = filteredById;
        return result;
      } else {
        const result = {};
        return result;
      }
    } catch (error) {
      throw error;
    }
  },
});
